export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7495.14ac9734.jpg";